module.exports = __webpack_public_path__ + "img/text_04.261ca2ef.png";